import styled from 'styled-components';
import { Flex } from 'common/common-components.styled';

export const StyledContainer = styled(Flex)`
  position: relative;
  min-height: 50px;
`;
